// extracted by mini-css-extract-plugin
export default {"empty":"cCoRStWaFNFNLpurUiT_","common_bganimation":"b8tWVvxBctrTxn9HjZR5"};